module.exports = __webpack_public_path__ + "img/bg_05.05627695.png";